import Scroller from "./Scroller";
import gsap from "gsap";

class Menu {
  constructor() {
    this.header = document.querySelector("#header");
    this.nav = document.querySelector("#menu-nav");
    this.lastScrollPosition = 0;
    this.tl = null;
  }

  init() {
    this.initAnim();
    window.addEventListener("scroll", this.menuScroll);
    this.initMenuScrollBlocking();
  }

  close() {
    if (this.nav) {
      this.nav.hidePopover();
    }
  }

  initAnim() {
    if (!this.nav) return;

    // 1. On cible les éléments
    const links = this.nav.querySelectorAll("ul li .anim-wrap");
    const imageWrap = this.nav.querySelector(".ligne.top .img-wrap");
    const image = this.nav.querySelector(".ligne.top .img-wrap img");
    const botElements = this.nav.querySelectorAll(
      ".ligne.bot .wrap, .ligne.bot .logo"
    );

    // 2. Setup initial de l'état caché (La touche Osmo !)
    gsap.set(links, { yPercent: 120, rotateZ: 3, transformOrigin: "0% 0%" });
    if (imageWrap) gsap.set(imageWrap, { clipPath: "inset(100% 0% 0% 0%)" }); // Effet rideau vers le haut
    if (image) gsap.set(image, { scale: 1.3 }); // Léger dézoom
    gsap.set(botElements, { autoAlpha: 0, y: 20 });

    // 3. Création de la Timeline (en pause par défaut)
    this.tl = gsap.timeline({
      paused: true,
      defaults: { ease: "expo.out", duration: 1.2 },
    });

    // --- SÉQUENCE D'OUVERTURE ---

    // A. Le rideau de l'image s'ouvre et l'image dézoome
    if (imageWrap && image) {
      this.tl
        .to(imageWrap, { clipPath: "inset(0% 0% 0% 0%)" }, 0)
        .to(image, { scale: 1 }, 0);
    }

    // B. Les liens remontent un par un avec la rotation qui s'annule
    this.tl.to(
      links,
      {
        yPercent: 0,
        rotateZ: 0,
        stagger: 0.05,
        duration: 1,
      },
      0.1
    ); // Démarre 0.1s après le début de l'image

    // C. Les éléments du bas apparaissent en fondu
    this.tl.to(
      botElements,
      {
        autoAlpha: 1,
        y: 0,
        stagger: 0.1,
        duration: 0.8,
      },
      0.3
    );
  }

  initMenuScrollBlocking = () => {
    this.nav.addEventListener("toggle", (event) => {
      if (event.newState === "open") {
        this.header.classList.add("is-open");
        document.documentElement.style.overflow = "hidden";
        Scroller.stop();
        this.tl.timeScale(1).play();
      } else {
        this.header.classList.remove("is-open");
        document.documentElement.style.overflow = null;
        Scroller.start();
        this.tl.timeScale(2).reverse();
      }
    });
  };
  menuScroll = () => {
    // Show/hide header depending on scroll direction
    if (
      window.pageYOffset >= window.innerHeight &&
      this.lastScrollPosition < window.pageYOffset
    ) {
      this.header.classList.add("is-hidden");
    } else {
      this.header.classList.remove("is-hidden");
    }
    this.lastScrollPosition = window.pageYOffset;
  };
}

export default new Menu();
